module.exports = __webpack_public_path__ + "img/busca-tematica-especies-prioritaria.dc56adda.jpg";